import { EKEPairingConverter } from "@src/component/exercise/engine/EKEPairingExerciseEngine/EKEPairingConverter";

export class EKEPairingDnDConverter extends EKEPairingConverter {
    public needAlingmentInput = true;    
    public pair2FixedType = false;
}